import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LineStatusEnumAction, LineStatusEnumLabel, RFQsSentMenuActionEnum, RFQsSentMenuLabelEnum } from '../../model/enum';

@Component({
  selector: 'app-button-dropdown-renderer',
  templateUrl: './button-dropdown-renderer.component.html',
  styleUrls: ['./button-dropdown-renderer.component.scss']
})
export class ButtonDropdownRendererComponent implements OnInit, ICellRendererAngularComp {
  params: any;
  value: string = '';
  isOpen = false;
  menuItems = [
    { label: RFQsSentMenuLabelEnum.ADD_OFFER, action: RFQsSentMenuActionEnum.ADD_OFFER },
    { label: RFQsSentMenuLabelEnum.ADD_ALTERNATE_OFFER, action: RFQsSentMenuActionEnum.ADD_ALTERNATE_OFFER },
    { label: RFQsSentMenuLabelEnum.MARK_NA, action: RFQsSentMenuActionEnum.MARK_NA },
    { label: RFQsSentMenuLabelEnum.NO_BID, action: RFQsSentMenuActionEnum.NO_BID },
  ];
  isAddResultDropdown: boolean = false;
  isReadyStatusDropdown: boolean = false;
  lineStatusOptions = [{ label: LineStatusEnumLabel.MARK_NO_BID, action: LineStatusEnumAction.MARK_NO_BID }, { label: LineStatusEnumLabel.MARK_READY, action: LineStatusEnumAction.MARK_READY }];

  constructor() { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.value = params.value ?? '';
    this.isReadyStatusDropdown = !!params?.colDef?.cellRendererParams?.isReadyStatusDropdown;
    this.isAddResultDropdown = !!params?.colDef?.cellRendererParams?.isAddResultDropdown;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    this.value = params.value ?? '';
    return true;
  }

  ngOnInit(): void { }

  onMenuItemClick(action: RFQsSentMenuActionEnum | string, event: MouseEvent) {
    const customEvent = new CustomEvent('resultActionClick', {
      detail: {action, data: this.params.data, gridId: this.params?.context?.storageName}
    });
    document.dispatchEvent(customEvent);
  }

  onLineStatusSelected(action: LineStatusEnumAction | string){
    const customEvent = new CustomEvent('lineStatusClick', {
      detail: {action, data: this.params.data}
    });
    document.dispatchEvent(customEvent);
  }
}
